import { useRecoilState } from "recoil";
import { qrDepositeModalAtom } from "../atoms/modalAtoms";

export const useQrDepositeModal = () => {
  const [isOpen, setIsOpen] = useRecoilState(qrDepositeModalAtom);
  return [isOpen, setIsOpen] as const;
};